module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": _vm.$t('IMPORTDATA'),
      "close-on-click-modal": false,
      "show-close": false,
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-card', {
    staticClass: "box-card",
    attrs: {
      "id": "import"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticStyle: {
      "line-height": "36px",
      "text-transform": "capitalize"
    }
  }, [_vm._v(_vm._s(_vm.$t('IMPORT') + ' ' + _vm.title))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "line-height": "36px",
      "float": "right"
    }
  }, [_c('i', {
    staticClass: "el-icon-warning text-danger"
  }), _vm._v(" " + _vm._s(_vm.$t('REQUIREDFIELDS')))])]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-select', {
    attrs: {
      "value-key": "field",
      "placeholder": _vm.$t('SELECTFIELD')
    },
    model: {
      value: (_vm.importField),
      callback: function($$v) {
        _vm.importField = $$v
      },
      expression: "importField"
    }
  }, _vm._l((_vm.fields), function(item, key) {
    return (_vm.isSet(item.field)) ? _c('el-option', {
      key: key,
      attrs: {
        "label": item.label,
        "value": item
      }
    }, [_vm._v("\n    " + _vm._s(item.label) + " "), (item.required) ? _c('i', {
      staticClass: "el-icon-warning text-danger",
      staticStyle: {
        "float": "right"
      }
    }) : _vm._e()]) : _vm._e()
  }))], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": !_vm.importField,
      "placeholder": _vm.$t('SELECTFIELDVALUE')
    },
    on: {
      "change": _vm.setValue
    },
    model: {
      value: (_vm.importValue),
      callback: function($$v) {
        _vm.importValue = $$v
      },
      expression: "importValue"
    }
  }, _vm._l((_vm.csv_reader), function(value, key) {
    return (_vm.isSet(key, true)) ? _c('el-option', {
      key: key,
      attrs: {
        "label": key + ':' + value,
        "value": key
      }
    }) : _vm._e()
  }))], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin": "-10px",
      "margin-top": "10px"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "height": 400,
      "highlight-current-row": "",
      "stripe": "",
      "data": _vm.importData
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "min-width": "120",
      "label": _vm.$t('DATAFIELDTYPE')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "value",
      "min-width": "130",
      "label": _vm.$t('DATAVALUE')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "csv_field",
      "min-width": "140",
      "label": _vm.$t('CSVCOLUMN')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('FORMAT'),
      "min-width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.format) ? _c('span', [_vm._v(_vm._s(_vm.$t('N/A')))]) : _vm._e(), _vm._v(" "), (scope.row.format) ? _c('el-select', {
          attrs: {
            "placeholder": _vm.$t('SELECTFORMAT')
          },
          model: {
            value: (scope.row.format_value),
            callback: function($$v) {
              _vm.$set(scope.row, "format_value", $$v)
            },
            expression: "scope.row.format_value"
          }
        }, _vm._l((_vm.formats[scope.row.format]), function(item, index) {
          return _c('el-option', {
            key: index,
            attrs: {
              "label": item.value,
              "value": item.format
            }
          })
        })) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "right",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "icon": "close"
          },
          on: {
            "click": function($event) {
              _vm.resetValue(scope.row.field)
            }
          }
        })]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-upload', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    ref: "upload",
    staticClass: "upload-demo",
    attrs: {
      "accept": ".csv",
      "action": _vm.URL + 'media/import',
      "headers": {
        'Accept-Language': _vm.currentLang()
      },
      "on-success": _vm.uploadedFile
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.cancelImport
    }
  }, [_vm._v(_vm._s(_vm.$t('CANCEL')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": _vm.required_fields != 0,
      "type": "primary",
      "loading": _vm.importing
    },
    on: {
      "click": _vm.startImporting
    }
  }, [_vm._v(_vm._s(_vm.importing ? _vm.$t('IMPORTINGDATA') : _vm.$t('STARTIMPORTING')))])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45195e83"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialogs/Import.vue
// module id = 595
// module chunks = 1